import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import { 
    Button,
    createStyles, 
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Theme, 
    withStyles, 
    WithStyles 
} from '@material-ui/core';
import { IReturn as Identification, actions as identificationActions } from '../../api/resources/Identification';

const styles = (theme: Theme) =>
    createStyles({
        
    });

interface IProps {
    identification: Identification;
    onDismiss: (shouldRefresh: boolean) => void;
    open: boolean;
};

type FullProps = IProps & WithStyles<typeof styles> & IDispatchProp;
class IdentificationDeleteModal extends React.PureComponent<FullProps> {
    render() {
        const { open } = this.props;
        
        return (
            <Dialog open={open} onClose={this.handleCancel} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Delete Identification?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you wish to delete this ID?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.handleSave} color="primary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    private handleCancel = () => {
        this.props.onDismiss(false);
    }

    private handleSave = () => {
        const { dispatch, identification } = this.props;
        dispatch(identificationActions.delete(identification.id)).catch(console.error);
        
        this.props.onDismiss(true);
    }
}

export default connect()(withStyles(styles)(IdentificationDeleteModal));